import elementResizeDetector from 'element-resize-detector';
import { debounce } from '../util/util';

export default {
  mounted() {
    if (this.erd) {
      this.erd.uninstall(this.$refs.sub);
      this.erd = null;
    }
    this.erd = elementResizeDetector();
    this.erd.listenTo(this.$refs.sub, debounce((element) => {
      this.handleResize();
    }, 100));
  },
  beforeDestroy() {
    if (this.erd) {
      this.erd.uninstall(this.$refs.sub);
      this.erd = null;
    }
  }
};
